// The patient's name as one string from the first/middle/last values, or '' without a first or last
// name (a middle name alone is not a name to show). The api builds the same string
// (Workflow::PatientName).
//
// A first name can still end with the middle name ("Jose M" beside "M"): someone typed it before
// extraction split the initial out, or the referral predates the split. The repeat is dropped
// instead of showing "Jose M M Ayala".
export function patientNameFrom(first: unknown, middle: unknown, last: unknown): string {
  const words = (value: unknown) => (typeof value === 'string' ? value.split(/\s+/).filter(Boolean) : []);
  const [given, extra, family] = [words(first), words(middle), words(last)];
  if (given.length === 0 && family.length === 0) return '';

  return [...given.slice(0, given.length - repeated(given, extra)), ...extra, ...family].join(' ');
}

// How many words at the end of the first name are the middle name, whole or as its initial.
function repeated(given: string[], extra: string[]): number {
  if (extra.length === 0) return 0;
  const bare = (list: string[]) => list.map((word) => word.replace(/\./g, '').toLowerCase());
  const [first, middle] = [bare(given), bare(extra)];

  if (first.length > middle.length && first.slice(-middle.length).join(' ') === middle.join(' ')) return middle.length;
  const last = first[first.length - 1];
  return first.length > 1 && last.length === 1 && last === middle[0][0] ? 1 : 0;
}
